import { Flex } from "@aircall/tractor";
import styled from "@xstyled/styled-components";

export const Container = styled(Flex).attrs({
  position: "relative",
  flexDirection: "column",
  backgroundColor: "surface-background",
})<{ isExpanded: boolean }>`
  flex: ${({ isExpanded }) => (isExpanded ? "1 0 100%" : "2")};
  min-height: 0;
`;
